(function ($) {
  "use strict";

  var hm = {
    init: function () {
      this.mainMenuBlock();
      this.mainMenuBlock1();
      this.submenuOpener();
      this.fixedHeader();
      this.scrollBTN();
      this.imgBannerCustomBox();
    },

    mainMenuBlock: function () {
      jQuery("header").on("click", ".navbar-toggle-btn", function (e) {
        e.preventDefault();
        if (!jQuery(this).hasClass("nav-open")) {
          jQuery("#navbar").removeClass("active");
          jQuery("html").removeClass("menu-active");
          jQuery(this).removeClass("nav-close").addClass("nav-open");
        } else {
          jQuery("#navbar").addClass("active");
          jQuery("html").addClass("menu-active");
          jQuery(this).removeClass("nav-open").addClass("nav-close");
        }
      });
    },

    mainMenuBlock1: function () {
      jQuery("header").on(
        "click",
        ".navbar-toggle-btn.nav-close",
        function (e) {
          jQuery("html").removeClass("submenu-active");
          jQuery(".nav-item").removeClass("opened");
          jQuery(".submenu-opener").removeClass("closed");
          jQuery(".dropdown-menu").css("display", "none");
        }
      );
    },

    submenuOpener: function () {
      jQuery("header.main-header .navbar-nav .submenu-opener").on(
        "click",
        function (e) {
          // e.preventDefault();
          jQuery("html").toggleClass("submenu-active");

          if (!jQuery(this).hasClass("closed")) {
            jQuery(this).addClass("closed");
            jQuery(this).parent(".nav-item").addClass("opened");
            jQuery(this).next(".dropdown-menu").slideToggle();
          } else {
            jQuery(this).removeClass("closed");
            jQuery(this).parent(".nav-item").removeClass("opened");
            jQuery(this).next(".dropdown-menu").slideToggle();
          }
        }
      );
    },

    fixedHeader: function () {
      jQuery(function () {
        function toggleStickyHeader() {
          var sticky = jQuery("header"),
            scroll = jQuery(window).scrollTop();

          if (scroll >= 1) {
            sticky.addClass("sticky-header");
          } else {
            sticky.removeClass("sticky-header");
          }
        }

        jQuery(window).on("scroll", toggleStickyHeader);
        toggleStickyHeader(); // Trigger once on page load
      });
    },

    scrollBTN: function () {
      document.addEventListener("DOMContentLoaded", function () {
        const scrollBtn = document.querySelector(".scroll-down-btn");
        const target = document.querySelector("#hero-box");

        const OFFSET_DESKTOP = 88; // px for ≥ 992px screens
        const OFFSET_MOBILE = 76;   // px for < 992px screens
        const DURATION = 800;       // scroll duration in ms

        if (scrollBtn && target) {
          scrollBtn.addEventListener("click", function (e) {
            e.preventDefault();

            const screenWidth = window.innerWidth;
            const OFFSET = screenWidth >= 992 ? OFFSET_DESKTOP : OFFSET_MOBILE;

            const startPosition = window.scrollY;
            const targetPosition =
              target.getBoundingClientRect().top + window.scrollY - OFFSET;
            const distance = targetPosition - startPosition;
            let startTime = null;

            function animationScroll(currentTime) {
              if (!startTime) startTime = currentTime;
              const timeElapsed = currentTime - startTime;
              const progress = Math.min(timeElapsed / DURATION, 1);

              // ease in-out function
              const ease =
                progress < 0.5
                  ? 2 * progress * progress
                  : -1 + (4 - 2 * progress) * progress;

              window.scrollTo(0, startPosition + distance * ease);

              if (timeElapsed < DURATION) {
                requestAnimationFrame(animationScroll);
              }
            }

            requestAnimationFrame(animationScroll);
          });
        }
      });

    },

    imgBannerCustomBox: function () {
      function adjustCustomBox() {
        const isDesktop = window.innerWidth >= 768;

        document.querySelectorAll(".img-banner.has-custom-box").forEach(section => {
          // Skip if section has .no-images
          if (section.classList.contains("no-image")) return;

          const box = section.querySelector(".custom-box");
          if (box) {
            if (isDesktop) {
              const boxHeight = box.offsetHeight;
              // Move the box upward by half its height
              box.style.top = (boxHeight / 2) + "px";
              // Add padding to section so image shifts down
              section.style.paddingTop = (boxHeight / 2) + "px";
              box.style.position = "absolute";
            } else {
              // Reset for mobile
              section.style.paddingTop = "";
              box.style.top = "";
              box.style.position = "relative";
            }
          }
        });
      }

      // Run on load and resize
      window.addEventListener("load", adjustCustomBox);
      window.addEventListener("resize", adjustCustomBox);



    },




  };

  hm.init();
})(jQuery);


